<template>
  <div>
    <!--使用默认配置-->
    <div style="width: 700px;padding-left: 25%;padding-top: 40px">
      <VueUEditor @ready="editorReady" :ueditorConfig="editorConfig"></VueUEditor>
    </div>
    <div style="width: 700px;padding-left: 25%;padding-top: 20px;">
      <el-button @click="getUeContent" size="mini">获取内容</el-button>
      <el-button @click="getUeContentText" size="mini">获取纯文本内容</el-button>
      <el-row :gutter="20">
        <el-col :span="12"><div style="background-color: #e6e8fb; height: 150px;">html：{{html}}</div></el-col>
        <el-col :span="12"><div style="background-color: #d5e3fb; height: 150px;">纯文本：{{content}}</div></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import VueUEditor from 'vue-ueditor'
  export default {
    name: 'demo-vue-ueditor',
    components: {
      VueUEditor
    },
    data () {
      return {
        editorConfig: {
          initialFrameHeight: 260,
          scaleEnabled: true,
          maximumWords: 1000, // 允许的最大字符数
          wordCount: true, // 是否开启字数统计
          wordCountMsg: '当前已输入 {#count} 个字符，您还可以输入{#leave} 个字符',
          wordOverFlowMsg: '<span style="color:red;">你输入的字符个数已经超出最大允许值，服务器可能会拒绝保存！</span>'
        },
        editorInstance: null,
        html: '',
        content: ''
      }
    },
    methods: {
      editorReady (editorInstance) {
        this.editorInstance = editorInstance
        // 你可以在这里初始化编辑器的初始内容
        editorInstance.setContent('Hello World!')
        editorInstance.addListener('contentChange', () => {
          this.html = editorInstance.getContent()
          this.content = editorInstance.getContentTxt()
        })
      },
      getUeContent() {
        this.$notify.info({title: '提示', message: this.editorInstance.getContent()})
      },
      getUeContentText() {
        this.$notify.info({title: '提示', message: this.editorInstance.getContentTxt()})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-vue-ueditor.vue